import Wallet from '@mui/icons-material/AccountBalanceWalletOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconEditProfile from '@mui/icons-material/SettingsOutlined';
import { useTheme } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

import Button from '@/components/Button';
import GenericDrawer from '@/components/GenericDrawer';
import { RootState } from '@/redux/store';
import EditProfile from '@/sections/EditProfile';
import RechargeBalance from '@/sections/RechargeBalance';

import useFirstShipment from './useFirstShipment';
import { StepCards } from './utils';

interface CardProps {
  stepNumber: number;
  StepIcon: React.FC;
  description: string;
  buttonText: string;
  buttonAction: () => void;
}

const FirstShipment = () => {
  const theme = useTheme();
  const { profile } = useSelector((state: RootState) => state.parcel);
  const { closeModals, completeData, recharge, openModals, sendShipment, verifyCoverage } =
    useFirstShipment();
  return (
    <>
      <Accordion
        sx={{
          borderRadius: '1rem',
          border: `2px solid ${theme.palette.primary.main}`,
          '&:before': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">¿Tu primer envío? Sigue este paso a paso</Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: 'flex', gap: '1rem', overflow: 'auto' }}>
          {StepCards({
            prepaid: profile.data?.configuration.paymentType === 'PREPAID',
            completeData,
            verifyCoverage,
            recharge,
            sendShipment,
          }).map((card, index) => (
            <Card key={index} {...card} stepNumber={index + 1} />
          ))}
        </AccordionDetails>
      </Accordion>
      <GenericDrawer
        open={openModals.completeData}
        onClose={closeModals}
        title={'Mis datos'}
        disableEscapeKeyDown={true}
        iconTitle={<IconEditProfile color="primary" />}
      >
        <EditProfile />
      </GenericDrawer>
      <GenericDrawer
        open={openModals.recharge}
        onClose={closeModals}
        title={'Recargar saldo'}
        disableEscapeKeyDown={true}
        iconTitle={<Wallet color="primary" />}
      >
        <RechargeBalance />
      </GenericDrawer>
    </>
  );
};

export default FirstShipment;

const Card = ({ stepNumber, StepIcon, description, buttonText, buttonAction }: CardProps) => {
  return (
    <Paper
      elevation={3}
      sx={{
        padding: '1rem',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: '1rem',
      }}
    >
      <Box display="flex" justifyContent="space-around">
        <Typography variant="h5" color="primary">
          {stepNumber}
        </Typography>
        <StepIcon />
      </Box>
      <Typography variant="body1">{description}</Typography>
      <Button onClick={buttonAction}>{buttonText}</Button>
    </Paper>
  );
};
